module.exports = __webpack_public_path__ + "static/media/bag.a06fe190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cart/bag.svg
// module id = 1938
// module chunks = 1